var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1143_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_855_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "m284.8 313.6h-115.2c-15.5 0-28-12.5-28-28s12.5-28 28-28h115.1c15.5 0 28 12.5 28 28s-12.5 28-27.9 28z",
    fill: "#F6C04B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "m343.3 457.6h-173.7c-9.7 0-18.7-5-23.8-13.3s-5.6-18.6-1.2-27.3c.2-.5 26.2-53.2 26.2-104 0-23.3-6-40.9-12.9-61.3-7.6-22.5-16.2-47.9-16.2-82 0-15.5 12.5-28 28-28s28 12.5 28 28c0 24.9 6.2 43 13.3 64.1 7.4 21.9 15.8 46.8 15.8 79.3s-7.9 64.5-15.8 88.5h132.4c15.5 0 28 12.5 28 28s-12.6 28-28.1 28z",
    fill: "#F6C04B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_856_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "m169.6 197.7c-15.5 0-28-12.5-28-28 0-63.3 51.5-114.8 114.8-114.8 49.1 0 92.8 31.2 108.7 77.7 5 14.6-2.8 30.5-17.4 35.6-14.6 5-30.5-2.8-35.6-17.4-8.1-23.8-30.5-39.8-55.7-39.8-32.4 0-58.8 26.4-58.8 58.8 0 15.4-12.5 27.9-28 27.9z",
    fill: "#F6C04B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPound);
export default __webpack_public_path__ + "static/media/pound.2048216608d36479ab3226d1ac4eebc7.svg";
export { ForwardRef as ReactComponent };